import { Controller } from "@hotwired/stimulus"

// Toggles a work-time-model period form between "fixed times" mode (per-weekday
// from/to/breaks) and "hours per day" mode (per-weekday net hours + optional
// standard times). The inactive table is hidden AND its inputs disabled so they
// are not submitted — the server rewrites day_details wholesale per mode.
export default class extends Controller {
  static targets = ["modeRadio", "fixedTable", "hoursTable"]

  connect() {
    this.apply()
  }

  switch() {
    this.apply()
  }

  apply() {
    const checked = this.modeRadioTargets.find((radio) => radio.checked)
    const hoursOnly = checked ? checked.value === "true" : false
    this.toggleSection(this.fixedTableTarget, !hoursOnly)
    this.toggleSection(this.hoursTableTarget, hoursOnly)
  }

  toggleSection(container, active) {
    container.classList.toggle("hidden", !active)
    container.querySelectorAll("input, select, button").forEach((element) => {
      element.disabled = !active
    })
  }
}
